<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint
      v-if="showHint"
      :value="hintText"
    />
    <div v-if="showError" class="form-fielderror">
      <label>!</label>
      <div class="form-fielderror-text">
        <div>{{ errorText }}</div>
      </div>
    </div>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <input
      type="text"
      class="form-control"
      :id="inputId"
      :placeholder="placeholder"
      autocomplete="off"
      :disabled="disabled"
      v-model="inputValue"
      @change="emit"
      @input="emit"
      @blur="emit"
      @keyup.enter="emit"
      @keyup.delete="emit"
    />
    <typeahead
      :async-function="typeahead"
      :item-key="typeaheadItemKey"
      :limit="typeaheadLimit"
      :target="'#' + inputId"
      :value="inputValue"
      @input="$emit('typeahead-selected', $event)"
    >
      <template v-slot:item="props">
        <li
          v-for="(item, index) in props.items"
          :class="{ active: props.activeIndex === index }"
          v-bind:key="index"
        >
          <a role="button" @click="props.select(item)">
            <div v-html="props.highlight(item)"></div>
            <span style="margin-right: 0.5em">{{item.inn}}</span>
            <span>{{item.address}}</span>
          </a>
        </li>
      </template>
    </typeahead>

    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TypeaheadInput',

  components: { Hint },

  mixins: [
    applicationInputMixin
  ],

  props: {
    inputLabel: {
      type: String,
      default: 'Введите значение'
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: () => 'input-' + Math.random().toString(36).substr(2, 9)
    },

    typeahead: {
      type: Function,
      default: null
    },
    typeaheadData: {
      type: Array,
      default: () => []
    },
    typeaheadItemKey: {
      type: String,
      default: 'org_name'
    },
    typeaheadLimit: {
      type: Number,
      default: 5
    },
    selectTypeahead: {
      type: Function,
      default: () => {
      }
    },

    showError: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: ''
    },

    showHint: {
      type: Boolean,
      default: false
    },
    hintText: {
      type: String,
      default: ''
    },

    showCheckbox: {
      type: Boolean,
      default: false
    },
    checkboxValue: {
      type: [String, Number, Boolean],
      default: ''
    },
    checkboxLabel: {
      type: String,
      default: ''
    },
    checkboxId: {
      type: String,
      default: () => 'checkbox-' + Math.random().toString(36).substr(2, 9)
    },

    showTypeaheadDetails: {
      type: Boolean,
      default: true
    },

    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },

    customClass: {
      type: String,
      default: ''
    },

    checkboxChange: {
      type: Function,
      default: () => {
      }
    },

    showPowerOfAttorneySelect: {
      type: Boolean,
      default: false
    },
    powersOfAttorney: {
      type: Array,
      default: () => []
    },
    powerOfAttorneyEntityId: {
      type: [String, Number],
      default: null
    },
    powerOfAttorneyEntityType: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      internalValue: this.modelValue
    }
  },

  mounted () {
    this.internalValue = this.modelValue
  },

  computed: {
    inputValue: {
      get() {
        return this.internalValue
      },
      set(newValue) {
        this.internalValue = newValue
        this.$emit('input', newValue)
      }
    },
    formGroupClass() {
      return [
        'form-group',
        this.customClass,
        {
          'has-error': this.hasInputErrors
        }
      ]
    },

    hasInputErrors() {
      return this.errors && this.errors[this.inputName || 'value']
    },

    actualErrorMessage() {
      return this.errors?.[this.inputName || 'value']?.[0] || ''
    }
  },

  watch: {
    modelValue(newValue) {
      this.internalValue = newValue
    }
  },

  methods: {
    emit(event, eventName = 'change') {
      this.$emit(eventName, this.inputValue)
      this.$emit('input', this.inputValue)
    }
  }
}
</script>
